import { useLang } from "@/contexts/LanguageContext";

const ICONS = {
  bedrooms: "fa-solid fa-bed",
  bedrooms_1: "fa-solid fa-bed",
  beds: "fa-solid fa-mattress-pillow",
  beds_4: "fa-solid fa-mattress-pillow",
  baths: "fa-solid fa-bath",
  baths_1: "fa-solid fa-bath",
  kitchen: "fa-solid fa-utensils",
  parking: "fa-solid fa-square-parking",
  beach: "fa-solid fa-umbrella-beach",
  view: "fa-solid fa-water",
  living: "fa-solid fa-couch",
  wifi: "fa-solid fa-wifi",
};

export default function Property({ property }) {
  const { t } = useLang();
  const title = t(`property.title_${property.id}`);
  const sub = t(`property.sub_${property.id}`);

  return (
    <section id="la-casa" data-testid="property-section" className="bg-stone-100 py-24 md:py-40 grain">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-7">
            <p className="text-eyebrow text-[#E07A5F] mb-4">{t("property.eyebrow")}</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-stone-900">
              {title}
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-stone-700 text-lg leading-relaxed">{sub}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-stone-200 border border-stone-200">
          {property.features.map((k) => (
            <div
              key={k}
              data-testid={`feature-${k}`}
              className="bg-stone-50 p-6 md:p-8 hover:bg-white transition-colors group"
            >
              <i className={`${ICONS[k]} text-2xl md:text-3xl text-[#E07A5F] mb-5 block group-hover:scale-110 transition-transform`} />
              <h3 className="font-serif-display text-xl md:text-2xl text-stone-900 mb-2">
                {t(`property.features.${k}.t`)}
              </h3>
              <p className="text-sm text-stone-600">{t(`property.features.${k}.d`)}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {[
            { n: String(property.capacity), l: "Huéspedes" },
            { n: String(property.bedrooms), l: "Habitaciones" },
            { n: String(property.beds), l: "Camas" },
            { n: String(property.baths), l: "Baños" },
          ].map((s, i) => (
            <div key={i} className="border-l border-stone-300 pl-4 text-left">
              <div className="font-serif-display text-5xl md:text-6xl text-stone-900 leading-none">{s.n}</div>
              <div className="text-eyebrow text-stone-500 mt-2">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
